import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Sync"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-sync',
    templateUrl: './icon-sync.component.html',
    styleUrls: ['./icon-sync.component.scss'],
    standalone: false
})
export class IconSyncComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
